// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\EnumType.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { EnumItemMD } from '../../../../../../libs/com/MetaPattern/MDA/MD/EnumItemMD';

/**
 * 发布状态枚举 枚举类
 * 发布状态枚举
 */
export enum EnumPublishStatus {
  /** 等待中 : 等待中 */
  Pendding = 1,
  /** 构建完成 : 构建完成 */
  BuildComplete = 2,
  /** 部署 : 部署 */
  Deploy = 4,
  /** 完成 : 完成 */
  Complete = 8,
  /** 失败 : 失败 */
  Fail = 16
}

/**
 * 发布状态枚举 枚举元数据类
 * 获取枚举的元数据信息：名称、显示名称、描述、值
 */
export class EnumPublishStatusMD {
  private static items = [
    new EnumItemMD('Pendding', 1, '等待中', '等待中'),
    new EnumItemMD('BuildComplete', 2, '构建完成', '构建完成'),
    new EnumItemMD('Deploy', 4, '部署', '部署'),
    new EnumItemMD('Complete', 8, '完成', '完成'),
    new EnumItemMD('Fail', 16, '失败', '失败')
  ];

  static getItem(enumItem: EnumPublishStatus) {
    return this.items.find(item => item.name === EnumPublishStatus[enumItem]);
  }

  static getItemByName(enumItemName: string) {
    return this.items.find(item => item.name === enumItemName);
  }

  static getItemByValue(enumItemValue: number) {
    return this.items.find(item => item.value === enumItemValue);
  }

  static getItems() {
    return this.items;
  }
}
